namespace TabAurous.OMS {
    export interface RateMasterRow {
        CostId?: number;
        ProductId?: number;
        AttributeId?: number;
        Attribute?: string;
        FromWt?: number;
        ToWt?: number;
        FromDate?: string;
        ToDate?: string;
        PurStdRate?: number;
        SaleStdRate?: number;
        ProductTypeId?: number;
        ProductTypeName?: string;
        CategoryId?: number;
        CategoryName?: string;
        SubCategoryId?: number;
        SubCategoryName?: string;
        SieveId?: number;
        SieveName?: string;
        StoneColorId?: number;
        StoneColoreName?: string;
        QualityId?: number;
        QualityName?: string;
        ShapeId?: number;
        ShapeName?: string;
        StoneSizeId?: number;
        StoneSizeName?: string;
        ItemTypeId?: number;
    }

    export namespace RateMasterRow {
        export const idProperty = 'CostId';
        export const localTextPrefix = 'OMS.RateMaster';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            CostId = "CostId",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            FromWt = "FromWt",
            ToWt = "ToWt",
            FromDate = "FromDate",
            ToDate = "ToDate",
            PurStdRate = "PurStdRate",
            SaleStdRate = "SaleStdRate",
            ProductTypeId = "ProductTypeId",
            ProductTypeName = "ProductTypeName",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            SubCategoryName = "SubCategoryName",
            SieveId = "SieveId",
            SieveName = "SieveName",
            StoneColorId = "StoneColorId",
            StoneColoreName = "StoneColoreName",
            QualityId = "QualityId",
            QualityName = "QualityName",
            ShapeId = "ShapeId",
            ShapeName = "ShapeName",
            StoneSizeId = "StoneSizeId",
            StoneSizeName = "StoneSizeName",
            ItemTypeId = "ItemTypeId"
        }
    }
}
